'use client';

import Image from 'next/image';

const Preview = ({ src, alt = 'Preview', maxSize = 300 }) => {
  const fileUrl = src && typeof src === 'object' ? src.previewUrl || src.fileUrl : src || null;
  const isPdf = fileUrl?.toLowerCase().endsWith('.pdf');

  if (!fileUrl) {
    return (
      <div className="flex flex-col form-section h-full">
        <h3 className="font-semibold text-md mb-3 sm:mb-4">Preview</h3>
        <div className="mx-auto w-full flex items-center justify-center rounded-lg text-gray-400" style={{ maxWidth: maxSize, height: maxSize }}>
          No document selected
        </div>
      </div>
    );
  }

  const proxyUrl = `/api/proxy?url=${encodeURIComponent(fileUrl)}`;

  if (isPdf) {
    return (
      <div className="flex flex-col form-section h-full">
        <h3 className="font-semibold text-md mb-3 sm:mb-4">Preview</h3>
        <div className="mx-auto w-full flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700" style={{ maxWidth: maxSize, height: maxSize }}>
          <iframe src={proxyUrl} className="w-full h-full rounded-md" title="PDF Preview" />
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col form-section h-full">
      <h3 className="font-semibold text-md mb-3 sm:mb-4">Preview</h3>
      <div className="mx-auto w-full flex items-center justify-center rounded-lg border border-gray-200" style={{ maxWidth: maxSize, height: maxSize }}>
        <Image
          src={proxyUrl}
          alt={alt}
          width={maxSize}
          height={maxSize}
          className="object-contain max-h-full max-w-full rounded-md"
          onError={(e) => {
            e.currentTarget.src = '/placeholder.png';
          }}
        />
      </div>
    </div>
  );
};

export default Preview;
